
<template>
  <div>
    <div class="header">
      <h2>{{$t('profile')}}</h2>
      
    </div>
    <hr />
  <loading :loadingText="`${$t('loading')}`" id="loadMe" :loadinSubText="`${$t('please_wait')}`"></loading>
    <input
      ref="input"
      type="file"
      name="image"
      accept="image/*"
      @change="setImage"
    />

    <div class="content">
      <section class="cropper-area">
        <div class="img-cropper">
          <vue-cropper
            ref="cropper"
            :aspect-ratio="16 / 16"
            :src="imgSrc"
            preview=".preview"
          />
        </div>
        <div class="actions">
            <a
            href="#"
            role="button"
            @click.prevent="showFileChooser"
          >
           <i class="fa fa-file-image-o"></i>
            Upload Image
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="zoom(0.2)"
          >
          <i class="fa fa-search-plus"></i>
            Zoom In
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="zoom(-0.2)"
          >
          <i class="fa fa-search-minus"></i>
            Zoom Out
          </a>
          
          <a
            href="#"
            role="button"
            @click.prevent="rotate(90)"
          >
            Rotate +90deg
          </a>
          <a
            href="#"
            role="button"
            @click.prevent="rotate(-90)"
          >
            Rotate -90deg
          </a>
          <a
            ref="flipX"
            href="#"
            role="button"
            @click.prevent="flipX"
          >
            Flip X
          </a>
          <a
            ref="flipY"
            href="#"
            role="button"
            @click.prevent="flipY"
          >
            Flip Y
          </a>
          <a
            href="#"
            role="button"
            style="background:#ff0000"
            @click.prevent="cropImage"
          >
           <i class="fa fa-crop"></i>
            Crop
          </a>
           <a
            href="#"
            role="button"
            style="background:#1fad45"
            @click.prevent="upload"
          >
           <i class="fa fa-save"></i>
            Save
          </a>
        </div>
      </section>
      <section class="preview-area">
        <p>Preview</p>
        <div class="preview" />
        <p>Cropped Image</p>
        <div class="cropped-image">
          <img
            v-if="cropImg"
            :src="cropImg"
            alt="Cropped Image"
          />
          <div v-else class="crop-placeholder" />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs'
import 'cropperjs/dist/cropper.css'
import { services } from '../../src/vuex/api'
import VALoading  from '../../src/widgets/VALoading'
import config from '../../src/vuex/api/services/config'
import { mapGetters , mapActions } from 'vuex'
export default {
  components: {
    VueCropper,
    'loading': VALoading
  },
  data() {
    return {
      imgSrc: '',
      cropImg: '',
      postData:null,
      data: null,
    }
  },
  mounted: function(){
    this.imgSrc = config.serverURI + '/avatar/' + this.currentUser.contactNumber 
  },
   computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  methods: {
    upload: function () {
    if (this.cropImg.length > 0){
    var self = this
    const formData = new FormData()
    this.$refs.cropper.getCroppedCanvas({ maxWidth: 200,maxHeight: 200 }).toBlob((blob) => {
    formData.append('uploadFile', blob,'kalam.png')
    formData.append('section', 'profileImage'  )
    formData.append('filename', 'kalam' )
    formData.append('sectionId',0)

     $('#loadMe').modal('show')
     services.user.uploadProflePhoto(formData) //  .getPatientInfo()
    .then(function (response) {
    $('#loadMe').modal('hide')
     self.getUsers({})
    })
    .catch(function (err) {
     $('#loadMe').modal('hide')
     self.error = '' + err
    })
    })
    }
  },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL()
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
      // this.postData = this.$refs.cropper.getData()
      // const blob = new Blob([new Uint8Array(this.cropImg)], {type: file.type })
    },
    flipX() {
      const dom = this.$refs.flipX
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleX(scale)
      dom.setAttribute('data-scale', scale)
    },
    flipY() {
      const dom = this.$refs.flipY
      let scale = dom.getAttribute('data-scale')
      scale = scale ? -scale : -1
      this.$refs.cropper.scaleY(scale)
      dom.setAttribute('data-scale', scale)
    },
    getCropBoxData() {
      this.data = JSON.stringify(this.$refs.cropper.getCropBoxData(), null, 4)
    },
    getData() {
      this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4)
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY)
    },
    reset() {
      this.$refs.cropper.reset()
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg)
    },
    setCropBoxData() {
      if (!this.data) return
      this.$refs.cropper.setCropBoxData(JSON.parse(this.data))
    },
    setData() {
      if (!this.data) return
      this.$refs.cropper.setData(JSON.parse(this.data))
    },
    setImage(e) {
      const file = e.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file')
        return
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader()
        reader.onload = (event) => {
          this.imgSrc = event.target.result
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result)
        }
        reader.readAsDataURL(file)
      } else {
        alert('Sorry, FileReader API not supported')
      }
    },
    showFileChooser() {
      this.$refs.input.click()
    },
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent)
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

input[type="file"] {
  display: none;
}


.content {
  display: flex;
  justify-content: space-between;
}
.cropper-area {
  width: 50%;
}
.actions {
  margin-top: 1rem;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #0062CC;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  width: 40%;
}
.preview-area p {
  font-size: 1.25rem;
  margin: 0;
  margin-bottom: 1rem;
}
.preview-area p:last-of-type {
  margin-top: 1rem;
}
.preview {
  width: 100%;
  height: calc(372px * (9 / 9));
  overflow: hidden;
}
.crop-placeholder {
  width: 100%;
  height: calc(372px * (9 / 9));
  background: #ccc;
}
.cropped-image img {
  max-width: 75%;
}
</style>




// WEBPACK FOOTER //
// Profile.vue?7e27bd81